export default {"src":"/_next/static/media/possibility-of-visiting.ee5d2e90.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};